import { useTranslation } from 'react-i18next';
import { ClassThemeProvider } from '@class-ui/theme';
import { useParams } from 'react-router-dom';

import ClassroomContent from '../components/classroom/ClassroomContent';
import { LtiRoutesParams } from '../components/classroom/ClassroomRoutes';
import { ClassProvider } from '../context/ClassContext';
import DownloadChatContainer from '../views/AdminSettings/DownloadChatContainer';
import Loadable from '../components/common/loadable';

const Classroom = () => {
    const { ready } = useTranslation('lti');
    const { classUuid } = useParams<LtiRoutesParams>();

    return (
        <Loadable isLoading={!ready}>
            <ClassThemeProvider>
                <ClassProvider classUuid={classUuid}>
                    <DownloadChatContainer.Provider>
                        <ClassroomContent />
                    </DownloadChatContainer.Provider>
                </ClassProvider>
            </ClassThemeProvider>
        </Loadable>
    );
};

export default Classroom;
